import { deletedata } from '@/util/global';
import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';

const  TableBill = ({ billdata }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(billdata);
    
  const rows = [];
  for (let i = 0; i < view.length; i++) {
    const a = view[i];
    rows.push(
      <tr key={a._id || i}>
        <td>{a.date.substring(2).split("-").reverse().join("/")}</td>

        <td>{a.vendor_name}</td>
        <td>{a.created_by}</td>
        <td>{a.last_modified_by}</td>
        <td>{a.status}</td>
        <td>
          <a href={`https://books.zoho.in/app/60022040726#/bills/${a.bill_id}?filter_by=Status.All&per_page=200&sort_column=created_time&sort_order=D`} target="_blank">view</a>
        </td>
      </tr>
    );
  }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
    <>
      <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} /> 
      <table className="grid">
        <thead>
          <tr>
            {th('date', 'date')}
            {th('vendor_name', 'vendor name')}
            {th('created_by', 'created by')}
            {th('last_modified_by', 'modified by')}
            {th('status', 'status')}
            <th style={{ width: '80px' }}>action</th>

          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

export default TableBill;
